import React, { useEffect, useState, FC } from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Grid, Header, Segment, Form, Button, InputOnChangeData, Image } from 'semantic-ui-react';
import { ApplicationState } from '../store';
import { actionCreators } from '../store/User';
import { MEBUser } from '../services/userService';
import { bindActionCreators, Dispatch } from 'redux';
import { AlertState } from '../store/AlertState';
import Alert from './Alert';
import { getLoginMessage  } from '../api/LoginPageMessage';

interface LoginFormData {
	username: string;
	password: string;
}

const initialState: LoginFormData = { username: '', password: '' };

type LoginPageProps = LoginState & typeof actionCreators & RouteComponentProps<{}>;

const LoginPage: FC<LoginPageProps> = (props: LoginPageProps) => {
	const [formData, setFormData] = useState<LoginFormData>(initialState);
	const [message, setMessage] = useState<string>('');

	useEffect(() => {
			async function loadLoginMessage() {
					try {
							const message = await getLoginMessage();
							setMessage(message);
					} catch (error) {
							console.error('Failed to fetch login message:', error);
					}
			}

			loadLoginMessage();
	}, []);


	const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>, { name, value }: InputOnChangeData) => {
		setFormData(prevState => ({ ...prevState, [name]: value }));
	};

	const handleLoginClick = async () => {
		if (formData.username.length > 0 && formData.password.length > 0) {
			await props.login(formData.username, formData.password, props.history);

			// After successful login, navigate to '/'
			props.history.push('/');
		}
	};

	return (
		<Grid textAlign='center' style={{ height: '70vh', marginTop: 100 }} verticalAlign='middle'>
			<Grid.Column style={{ maxWidth: 450 }}>
				{ message !== '' && (
					<div style={{ fontSize: 14, fontWeight: 'bold', color: 'red' }}>
						{message}
						<br />
					</div>
					) }
				<Header as='h2' color='blue' textAlign='center'>
					Log In
				</Header>
				<Form size='large'>
					<Segment stacked>
						<Form.Input
							fluid
							icon='user'
							iconPosition='left'
							placeholder='Username'
							name='username'
							value={formData.username}
							type='text'
							onChange={handleInputChange}
						/>
						<Form.Input
							fluid
							icon='lock'
							iconPosition='left'
							placeholder='Password'
							name='password'
							value={formData.password}
							type='password'
							onChange={handleInputChange}
						/>
						<Button onClick={handleLoginClick} color='blue' fluid size='large'>
							Login
						</Button>
						{props.alert.message ? (
							<Alert message={props.alert.message} negative={props.alert.type === 'negative'} />
						) : null}
					</Segment>
					<Image style={{ margin: 'auto', width: 250, height: 'auto' }} src={require('../Images/MicroconLogo.png')} />
				</Form>
			</Grid.Column>
		</Grid>
	);
};

interface LoginState {
	user: MEBUser | undefined;
	alert: AlertState;
}

const mapState = (state: ApplicationState): LoginState => ({
	user: state.user,
	alert: state.alert
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(actionCreators, dispatch);

export default withRouter(connect(mapState, mapDispatchToProps)(LoginPage));
